import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import CalendarContainer from '@calendar/containers/CalendarContainer.vue'
import { mapActions, mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
import * as dateutil from '@/util/date-helper'
import { EnumCalendarViewType } from '../types'

@Component({
    components: { PageHeaderWithActionBar, CalendarContainer },
    computed: {
        ...mapGetters({
            currentDate: types.COMMON_DATE_CURRENT,
            currentMode: types.CALENDAR_VIEWMODE
        })
    },
    methods: {
        ...mapActions({
            selectToday: types.COMMON_DATE_SELECT_TODAY
        })
    }
})
export default class CalendarView extends Vue {

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentDate!: calendar.DateItem
    currentMode!: EnumCalendarViewType

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectToday!: () => Promise<any>
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    modeChangeOpen: boolean = false
    mode: string = 'month'

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    get dateDisplay() {
        return dateutil.uGetDateFormat(this.$t('M_Schedule_Dateformat2').toString(), this.currentDate.date)
    }

    modeChange(mode: string) {
        this.mode = mode
        this.modeChangeOpen = false
    }

    goToday() {
        this.selectToday().then(res => {
            if (this.mode == 'week') {
                this.$nextTick(() => {
                    var dayWrap = document.getElementsByClassName('schedule week')[0] as HTMLElement;
                    var todayElem = document.getElementsByClassName('date-select today')[0] as HTMLElement;
                    dayWrap.scrollLeft = todayElem.offsetLeft;
                })
            }
        })
    }

    prev() {
        (this.$refs.calendarContainer as any).prev()
    }

    next() {
        (this.$refs.calendarContainer as any).next()
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.mode = this.currentMode
    }
}
